(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirea63f"];
var parcelRegister = parcelRequire.register;
parcelRegister("igKPH", function(module, exports) {

$parcel$export(module.exports, "splitPathsBySizeLoader", () => $d4ce0ca9183abc81$export$c977b52d171987bb);
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gztBd = parcelRequire("gztBd");

var $704DA = parcelRequire("704DA");

var $leH9B = parcelRequire("leH9B");


var $d4ce0ca9183abc81$export$c977b52d171987bb = function(name, size) {
    return (0, $gztBd.__awaiter)(void 0, void 0, void 0, function() {
        var key, pathsRecord;
        return (0, $gztBd.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    key = (0, $704DA.pascalCase)(name);
                    if (!(size === (0, $leH9B.IconSize).STANDARD)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (parcelRequire("aNN1w"))
                    ];
                case 1:
                    pathsRecord = _a.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        (parcelRequire("15Bfz"))
                    ];
                case 3:
                    pathsRecord = _a.sent();
                    _a.label = 4;
                case 4:
                    return [
                        2 /*return*/ ,
                        pathsRecord[key]
                    ];
            }
        });
    });
};

});
parcelRegister("aNN1w", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("lGiiH")).then(()=>parcelRequire("lyZPJ"));

});

parcelRegister("15Bfz", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("YXxaF")).then(()=>parcelRequire("adNjr"));

});


})();
//# sourceMappingURL=splitPathsBySizeLoader.js.map
